import { Component, ViewChild } from '@angular/core'
import {
  SeFeLayoutComponent,
  SeFeLeftNavRouterService,
  SeFeLeftNavEvent
} from 'se-fe-left-nav'

import { NAV_TREE } from './docs-app-nav-tree'

@Component({
  selector: 'se-docs-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  @ViewChild('layout') private layout!: SeFeLayoutComponent

  public navTree = NAV_TREE
  public footerLinks = []

  constructor(private routerService: SeFeLeftNavRouterService) { }

  public handleNavigate(e: SeFeLeftNavEvent): void {
    this.routerService.handleNavigate(e)
    this.layout.closeLeftNav()
  }
}
